/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The EventsControllerDtoEventInvitationHistoryListEventInvitationHistoryData model module.
 * @module model/EventsControllerDtoEventInvitationHistoryListEventInvitationHistoryData
 * @version 1.0
 */
class EventsControllerDtoEventInvitationHistoryListEventInvitationHistoryData {
    /**
     * Constructs a new <code>EventsControllerDtoEventInvitationHistoryListEventInvitationHistoryData</code>.
     * @alias module:model/EventsControllerDtoEventInvitationHistoryListEventInvitationHistoryData
     */
    constructor() { 
        
        EventsControllerDtoEventInvitationHistoryListEventInvitationHistoryData.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>EventsControllerDtoEventInvitationHistoryListEventInvitationHistoryData</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/EventsControllerDtoEventInvitationHistoryListEventInvitationHistoryData} obj Optional instance to populate.
     * @return {module:model/EventsControllerDtoEventInvitationHistoryListEventInvitationHistoryData} The populated <code>EventsControllerDtoEventInvitationHistoryListEventInvitationHistoryData</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new EventsControllerDtoEventInvitationHistoryListEventInvitationHistoryData();

            if (data.hasOwnProperty('inviterAccountNo')) {
                obj['inviterAccountNo'] = ApiClient.convertToType(data['inviterAccountNo'], 'Number');
            }
            if (data.hasOwnProperty('inviterEmail')) {
                obj['inviterEmail'] = ApiClient.convertToType(data['inviterEmail'], 'String');
            }
            if (data.hasOwnProperty('invitedAccountNo')) {
                obj['invitedAccountNo'] = ApiClient.convertToType(data['invitedAccountNo'], 'Number');
            }
            if (data.hasOwnProperty('invitedEmail')) {
                obj['invitedEmail'] = ApiClient.convertToType(data['invitedEmail'], 'String');
            }
            if (data.hasOwnProperty('invCode')) {
                obj['invCode'] = ApiClient.convertToType(data['invCode'], 'String');
            }
            if (data.hasOwnProperty('createdAt')) {
                obj['createdAt'] = ApiClient.convertToType(data['createdAt'], 'Date');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>EventsControllerDtoEventInvitationHistoryListEventInvitationHistoryData</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>EventsControllerDtoEventInvitationHistoryListEventInvitationHistoryData</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['inviterEmail'] && !(typeof data['inviterEmail'] === 'string' || data['inviterEmail'] instanceof String)) {
            throw new Error("Expected the field `inviterEmail` to be a primitive type in the JSON string but got " + data['inviterEmail']);
        }
        // ensure the json data is a string
        if (data['invitedEmail'] && !(typeof data['invitedEmail'] === 'string' || data['invitedEmail'] instanceof String)) {
            throw new Error("Expected the field `invitedEmail` to be a primitive type in the JSON string but got " + data['invitedEmail']);
        }
        // ensure the json data is a string
        if (data['invCode'] && !(typeof data['invCode'] === 'string' || data['invCode'] instanceof String)) {
            throw new Error("Expected the field `invCode` to be a primitive type in the JSON string but got " + data['invCode']);
        }

        return true;
    }


}



/**
 * @member {Number} inviterAccountNo
 */
EventsControllerDtoEventInvitationHistoryListEventInvitationHistoryData.prototype['inviterAccountNo'] = undefined;

/**
 * @member {String} inviterEmail
 */
EventsControllerDtoEventInvitationHistoryListEventInvitationHistoryData.prototype['inviterEmail'] = undefined;

/**
 * @member {Number} invitedAccountNo
 */
EventsControllerDtoEventInvitationHistoryListEventInvitationHistoryData.prototype['invitedAccountNo'] = undefined;

/**
 * @member {String} invitedEmail
 */
EventsControllerDtoEventInvitationHistoryListEventInvitationHistoryData.prototype['invitedEmail'] = undefined;

/**
 * @member {String} invCode
 */
EventsControllerDtoEventInvitationHistoryListEventInvitationHistoryData.prototype['invCode'] = undefined;

/**
 * @member {Date} createdAt
 */
EventsControllerDtoEventInvitationHistoryListEventInvitationHistoryData.prototype['createdAt'] = undefined;






export default EventsControllerDtoEventInvitationHistoryListEventInvitationHistoryData;

